export default {
  faqTitle: 'Ray Sigorta  Hakkında Merak Edilen Sorular',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  products: {
    title: 'Ray Sigorta Ürünleri',
    buttons: [
      {
        id: 1,
        title: 'TRAFİK SİGORTASI',
        class: 'company--btn--icons fas fa-car fa-2x mr-2',
        path: 'RaySigortaCompulsoryTraffic'
      },
      {
        id: 2,
        title: 'KASKO SİGORTASI',
        class: 'company--btn--icons fas fa-car-crash fa-2x mr-2',
        path: 'RaySigortaMotorInsurance'
      },
      {
        id: 3,
        title: 'DASK SİGORTA',
        class: 'company--btn--icons fas fa-laptop-house fa-2x mr-2',
        path: 'RaySigortaDaskInsurance'
      },
      {
        id: 4,
        title: 'KONUT SİGORTASI',
        class: 'company--btn--icons fas fa-house-damage fa-2x mr-2',
        path: 'RaySigortaHomeInsurance'
      },
      {
        id: 5,
        title: 'İŞYERİ SİGORTASI',
        class: 'company--btn--icons fas fa-building  fa-2x mr-2',
        path: 'RaySigortaCompanyInsurance'
      },
      {
        id: 6,
        title: 'FERDİ KAZA SİGORTASI',
        class: 'company--btn--icons fas fa-user-injured fa-2x mr-2',
        path: 'RaySigortaPersonalAccident'
      },
      {
        id: 7,
        title: 'NAKLİYAT SİGORTASI',
        class: 'company--btn--icons fas fa-luggage-cart fa-2x mr-2',
        path: 'RaySigortaTransportation'
      },

      {
        id: 8,
        title: 'TAMAMLAYICI SAĞLIK SİGORTASI',
        class: 'company--btn--icons fas fa-briefcase-medical fa-2x mr-2',
        path: 'RaySigortaComplementaryHealth'
      },

      {
        id: 10,
        title: 'SEYAHAT SAĞLIK SİGORTASI',
        class: 'company--btn--icons fas fa-umbrella-beach fa-2x mr-2',
        path: 'RaySigortaTravelInsurance'
      }
    ]
  },
  introContent: {
    title: 'Ray Sigorta Hakkında',
    content: [
      {
        paragraph:
          'Ray Sigorta A.Ş. 1958 yılında, taşımacılıkta Ulusal olan şirketlerinin Denizcilik İşletmeleri, THY, PTT, Devlet Demiryolları girişimleri ile kurulmuştur. '
      },
      {
        paragraph: '1992 yılında Doğan Holding ile özelleştirilmiştir'
      },
      {
        paragraph:
          '1997 yılında Hisse senetleri İMKB ‘de işleme başlamıştır. Ray Sigorta çalıştığı her branşta ekstra özel teklifleri ile müşterilerine ayrıcalıklı ürünler sunmaktadır. '
      },
      {
        paragraph:
          '2016 yılı poliçe prim üretimi 568.717,000 TL olurken, 2017 yılı poliçe prim üretimi 706.217,663 TL olarak artmıştır. Şirketin ortaklık yapısındaki % 5,7‘lik hisse halka açık olarak değiştirilmiştir.'
      },
      {
        paragraph:
          'Doğru işe doğru uzmanı yerleştirme hedefiyle ilerleyen Ray Sigorta sigortalılarına kaliteli hizmet vermeyi amaç edinmiştir.'
      }
    ]
  },
  questions: [
    {
      title: 'Ray Sigorta Ürün Çeşitleri Nelerdir?',
      content: [
        {
          paragraph:
            'Ray Sigorta Alokasko’nun anlaşmalı olduğu sigorta şirketlerindendir. Ray Sigorta’nın müşterileri için hazırlamış olduğu sigorta ürünlerinden siz özel fiyat sunabileceğimiz branşlar:',
          subList: [
            'Trafik Sigortası',
            'Araç Kasko Sigortası',
            'DASK (Zorunlu Deprem Sigortası)',
            'Konut Sigortası',
            'İşyeri Sigortası',
            'Ferdi Kaza Sigortası',
            'Nakliyat Sigortası',
            'Tamamlayıcı Sağlık Sigortası',
            'Seyahat Sağlık Sigortası'
          ]
        },
        {
          paragraph:
            'Ray Sigorta’dan teklif almak isteyen tüm müşterilerimiz <strong><em><u>alokasko.com</u></em></strong> sayfamızdan minimum fiyat avantajı ile maksimum teminat ve tekliflere ulaşabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Ray Sigorta Zorunlu Trafik Sigortası Nedir?',
      content: [
        {
          paragraph:
            "2918 sayılı Karayolları Trafik Kanunu'na tabi olan zorunlu trafik sigortası karşı araca vereceğiniz zararları ve hasarları güvence altına almaktadır.",
          subList: null
        },
        {
          paragraph:
            'Kanunen yaptırılması zorunlu olan trafik sigortanızı her yıl düzenli olarak yeniletmelisiniz. Bitiş tarihini takip etmeli ve güvencenizi aralıksız devam ettirmelisiniz.',
          subList: null
        },
        {
          paragraph:
            'Ray Sigorta kapsamında 3. Şahıslara vereceğiniz hasarları güvence altına almak için teklif al formunu doldurabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Ray Sigorta Araç Kasko Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Kasko Sigortası aracınızı tam kapsamlı güvence altına alabilir. Poliçenize ekleyeceğiniz geniş kapsamlı teminatlar aracınızı ve bütçenizi 1 yıl boyunca korur. Araç kasko sigortası olası kaza durumlarında, aracın çalınma durumlarında ya da aracınızın yanma durumlarında destek alabileceğiniz sigorta türüdür. Bunun dışında kaskonun karşılayacağı durumlar eklenen teminatlara göre değişiklik gösterecektir. Bu durumda sunulan teminatları incelemeden poliçenizi onaylamamalısınız. Gereksiz eklenen teminatlar primleri arttıracağı gibi, en az teminatta hasar durumlarında yetersiz kalacaktır. En doğru planı almaya özen göstermeniz için Alokasko uzmanları her zaman size destek olur. ',
          subList: null
        },
        {
          paragraph:
            '%15 ila %25 arasında meslek indirimi sunan Ray Kasko Sigortası araç sürücüleri tarafından tercih edilen ürünler arasındadır.',
          subList: null
        },
        {
          paragraph:
            '<strong><em><u>Ray Sigorta Kasko Ürünleri: </u></em></strong>',
          subList: [
            'Ekonomik Kasko',
            'Prenses Kasko',
            'Baby On Board Kasko',
            '2. Şans Kasko'
          ]
        },
        {
          paragraph:
            'Ray Sigorta, Genişletilmiş Kasko teminatları aşağıdaki gibidir ;',
          subList: [
            'Çarpma, çarpışma, devrilme, yanma',
            'Aracın çalınması',
            'Yetkili olmayan kişilerce sigortalı aracın çekilmesi',
            'GLHH, terör ve üçüncü kişilerin kötü niyetli hareketleri ',
            'Deprem, fırtına, dolu, yıldırım, toprak kayması ve yanardağ püskürmesi',
            'Sel, su baskını',
            'Sigara ve benzeri zararlar',
            'Anahtar kaybı, kilit mekanizma değişikliği ',
            'Kemirgen hayvan zararları',
            'Yanlış akaryakıt dolumu ',
            'Özel eşya teminatı ',
            'İMM teminatı',
            'Ferdi kaza teminatı',
            'Mini onarım hizmeti'
          ]
        },
        {
          paragraph:
            'Tüm teminatlar Genişletilmiş Kasko teminatları kapsamındadır.',
          subList: null
        },
        {
          paragraph:
            'Ayrıca Ray Sigorta tarafından size özel meslek indirimleri, servis seçimleri, 0-5 yaş arası çocuğu olan müşteriler ve kadınlara özel paketleri ile indirim sağlamaktadır. Ray Sigorta hem sizi hem de bütçenizi düşünerek kaliteli hizmet sunmayı hedeflemektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Ray Sigorta DASK – Zorunlu Deprem Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Zorunlu deprem sigortası ile depremin neden olabileceği maddi zararlar ve deprem sonucunda meydana gelen yangın, infilak, yer kayması ve tsunami hasarları güvence altına alınır.',
          subList: null
        },
        {
          paragraph:
            'Zorunlu deprem sigortası hesaplamalarında poliçe primi belirlenirken konutların yapı tarzı ve deprem risk bölgeleri dikkate alınır.',
          subList: null
        },
        {
          paragraph:
            'DASK Zorunlu Deprem Sigortanızı <strong><em><u>Ray Sigorta’dan</u></em></strong> yaptırarak depreme karşı güvencenizi başlatabilirsiniz. DASK fiyatlarını değerlendirmek isteyen adaylar teklif al formunu doldurabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Ray Sigorta Konut Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Kiracı ve ev sahiplerinin satın alabileceği “<strong><em><u>Ray Sigorta Evim Saray</u></em></strong>” ile hem eviniz hem de eşyalarınız güvence altında!',
          subList: null
        },
        {
          paragraph:
            'Konut sigortası kapsamında satın alacağınız güvenceye ek olarak Ray Sigorta yılda 1 defaya mahsus ücretsiz kombi ve klima bakımı hediye etmektedir.',
          subList: [
            'Cam İşleri Hizmeti ',
            'Çilingir Hizmeti ',
            'Elektrik Tesisatı Hizmeti ',
            'Su Tesisatı Hizmeti bulunur.'
          ]
        },
        {
          paragraph: 'Acil Durumlarda Faydalanabileceğiniz:',
          subList: null
        },
        {
          paragraph:
            '** Bunun dışında poliçe ile sunulan geniş kapsamlı asistans hizmetleri sayesinde avantajlarınız katlanır. Bu avantajlardan yararlanmak için teklif alabilir ve detaylı karşılaştırma yapabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Ray Sigorta İş Yeri Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Ray Sigorta “İş Yeri Güvence Sigortası” ile iş yeri olarak kullanılan bina, muhteviyat (demirbaş, makine-tesisat, emtea vb.) ve camlar güvence altına alınır. Ana teminatların yanı sıra poliçeye eklenecek diğer teminatlar sayesinde tam koruma elde edilebilir.',
          subList: null
        },
        {
          paragraph:
            'İhtiyaçlara özel hazırlanan iş yeri paket sigortası ile değer verdiğiniz iş yeriniz güvence altına!',
          subList: null
        },
        {
          paragraph:
            'Ray Sigorta “İş Yeri Güvence Sigortası” fiyatı almak için <strong><em><u>teklif al formunu</u></em></strong> doldurabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Ray Sigorta Ferdi Kaza Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Ray Sigorta Ferdi Kaza Sigortası gündelik hayatta karşılaşabileceğiniz ve kaza nedeniyle oluşabilecek riskleri teminat altına alır. Ray Sigorta “Ferdi Ray” ile hayati riskleri güvence altına alabilirsiniz.',
          subList: null
        },
        {
          paragraph: 'Ray Ferdi Kaza Sigortası teminatları;',
          subList: [
            'Vefat teminatı',
            'Bedensel zarar teminatı',
            'Tedavi masrafları teminatı',
            'Kaza durumunda sigortalının üçüncü kişilere vereceği zararlar güvence altındadır.'
          ]
        },
        {
          paragraph:
            '***Bu teminatların dışında sunulan hukuksal koruma teminatı Ferdi Ray Plus paketinde yer almaktadır.',
          subList: null
        },
        {
          paragraph:
            'Ferdi Kaza sigortası teminatlarından faydalanabilmeniz için oluşan kazanın iradeniz dışında olması gerekmektedir. Ferdi kaza sigortaları 1 yıllık olarak düzenlenir. ',
          subList: null
        }
      ]
    },
    {
      title: 'Ray Sigorta Nakliyat Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Ray Sigorta Nakliyat Emtea Sigortası, taşınan herhangi bir yükün, onun taşınmaya uygun karayolu, denizyolu, havayolu ve demiryolu nakil için kullanılan vasıtalarla bir yerden farklı bir yere taşınması sırasında uğrayabileceği her hasar ve kayıpları, poliçede belirlenmiş teminatlar ile karşılar.',
          subList: null
        },
        {
          paragraph:
            'Nakliyat Sigortası Genel Şartlar ve Özel Şartlar kapsamı ile güvence altına alan sigorta ürünüdür.',
          subList: null
        }
      ]
    },
    {
      title: 'Ray Sigorta Tamamlayıcı Sağlık Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Ray Sigorta “<strong>Tamamlayan Sağlık Sigortası</strong>” SGK kapsamında fark ücreti ödemeden özel hastanelerden hizmet almanızı sağlar. Ray Sigorta anlaşmalı hastane ağı listesinde yer alan hastanelerden poliçe kapsamında kaliteli hizmet alabilirsiniz. ',
          subList: null
        },
        {
          paragraph:
            'Ray Sigorta güvencesinde tamamlayıcı sağlık sigortası yaptırmak isteyen kişiler ilk şart olarak SGK’lı olmalıdır. İkinci şart olarak 0-64 yaş aralığında olmalıdır.',
          subList: null
        },
        {
          paragraph:
            'Ayakta ve yatarak tedavi teminatlarına ek olarak Ray Sigorta size özel ücretsiz check - up ve diş sağlığı paketi hediye etmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Ray Sigorta Seyahat Sağlık Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Ray Seyahat Sağlık Sigortası, yurtiçi ve yurt dışı seyahatlerinizde oluşabilecek kaza ve yaralanmalara karşı güvence sağlar. Bunun dışında tedavi giderleri, hastalık nedeni ile nakil, vefat eden sigortalının nakli, kaybolan bagajların bulunması bulunan bagajların sigortalıya ulaşımı ve yolculuk sırasında oluşabilecek tüm zorluklara karşı güvence altına alan sigorta ürünüdür.',
          subList: null
        },
        {
          paragraph: 'Ray Seyahat Sağlık Sigortası Paketleri:',
          subList: [
            'Keyfekeder Sigortası',
            'Tripplus Yurt Dışı Seyahat Sağlık Sigortası',
            'Tripplus Yurtiçi Seyahat Sağlık Sigortası',
            'Türkiye Vize Seyahat Sigortası'
          ]
        }
      ]
    },
    {
      title: 'Ray Sigorta Poliçe Sorgulama Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Mevcut poliçe sorgulaması yapmak isteyen sigortalılar Ray Sigorta’nın web site adresini ziyaret etmelidir. Yapmak istediğiniz sorgulama işlemi için “Online Hizmetler” sayfasına giriş yaparak TCKN/VKN ve Poliçe No alanını doldurarak ilerleyebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Ray Sigorta Hasar Dosya Sorgulama Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Ray Sigorta hasar dosya sorgulaması yapabilmeniz için hasar dosyanızı açtırmış olmanız gerekmektedir. İlgili hasar hakkında detaylı bilgileri öncelikle sigortacınızla paylaşmalısınız. Gerekli bilgileri ve evrakları iletmeniz durumunda hasar dosyanız açılacak ve işlemleriniz Ray Sigorta tarafından başlayacaktır.',
          subList: null
        },
        {
          paragraph:
            'Mevcut hasar dosyanızı sorgulamak için Kimlik Numaranız ve Dosya Numaranız ile işlem yapabilirsiniz. Ray Sigorta online işlemler sayfasına giriş yaparak sorgulamanızı gerçekleştirebilirsiniz.',
          subList: null
        },
        {
          paragraph:
            '<strong><em><u>alokasko.com</u></em></strong> web sitemizden satın aldığınız sigorta poliçeleri kapsamında yaşanan hasarlar için sigorta danışmanlarımızdan destek alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Ray Sigorta Poliçe Fiyatı Nasıl Alınır?',
      content: [
        {
          paragraph:
            'Ray Sigorta Fiyatlarını değerlendirmek için <strong><em><u>teklif al formunu</u></em></strong> doldurabilirsiniz.',
          subList: null
        }
      ]
    }
  ]
}
